import { PaginationTable, TableWrapper } from 'components/Global';
import { format, parseISO } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';
import { gotFeeCurrency } from 'utils/functionality';

const DriverBalance = ({ currentPage, setCurrentPage }) => {
  const { selected: driverData, history } = useSelector((state) => state.drivers);

  return (
    <TableWrapper title="Detail Saldo">
      <div className="driver__balance-info">
        <p style={{ fontSize: 12, marginBottom: 6 }}>Saldo Driver</p>
        <h3>{gotFeeCurrency(history?.available_fee_amount, driverData.user_location?.currency)}</h3>
      </div>
      <div className="driver__transaction-history">
        <h5>History Transaksi</h5>
        {history?.data?.length > 0 ? (
          history.data.map((item) => (
            <div className="driver__transaction-history__item" key={item.id}>
              <div>
                <p style={{ fontWeight: 'bold', marginBottom: 6 }}>{item.description}</p>
                <p style={{ fontSize: 12, color: '#A8A8A8' }}>{format(parseISO(item.date), 'dd MMMM yyyy HH:mm:ss')}</p>
              </div>
              <p
                style={{
                  fontWeight: 'bold',
                  color: item.amount > 0 ? '#299B0A' : '#EA2626',
                }}
              >
                {item.amount > 0
                  ? `+ ${gotFeeCurrency(Math.abs(item.amount), driverData.user_location?.currency)}`
                  : `- ${gotFeeCurrency(Math.abs(item.amount), driverData.user_location?.currency)}`}
              </p>
            </div>
          ))
        ) : (
          <div className="driver__transaction-history__empty">
            <p>Belum Ada Data Transaksi</p>
          </div>
        )}
      </div>
      <PaginationTable
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)}
        totalCount={history?.pagination?.total}
      />
    </TableWrapper>
  );
};

export default DriverBalance;
